export const statusChip = (theme) => ({
  root: {
    display: "inline-flex",
    flexDirection: "row",
    alignItems: "flex-end",
    height: "fit-content",
    width: "fit-content",
    backgroundColor: "#fff",
    borderStyle: "solid",
    borderRadius: 2,
    borderWidth: 1,
    ...theme.fonts.faces.bodyXS,
    // borderColor: theme.customPalette.secondaryYellowYButtons,
    // color: theme.customPalette.secondaryYellowYButtons,
    fontSize: "12px",
    lineHeight: "12px",
    fontWeight: "500",
    "&:first-letter": {
      textTransform: "capitalize",
    },
  },
  statusOk: {
    backgroundColor: "#fff",
    color: `${theme.customPalette.trueGreen} !important`,
    borderColor: theme.customPalette.trueGreen,
  },
  statusError: {
    backgroundColor: "#fff",
    color: `${theme.customPalette.coral} !important`,
    borderColor: theme.customPalette.coral,
  },
  name: {
    padding: theme.spacing(1),
    fontFamily: "Spezia",
    "&:first-letter": {
      textTransform: "capitalize",
    },
  },
  icon: {
    height: 0,
    width: 0,
    display: "none",
  },
});
